import { ISyncStatus } from './I-sync-status';
import { SyncStatus } from '../db-strings/sync-status';
import { DataConstants } from '../../../../../shared/consts/dataConstants';

export class InSync implements ISyncStatus {
  getSyncStatus(): SyncStatus {
    return SyncStatus.inSync;
  }
  getDbString(): string {
    return SyncStatus.inSync + DataConstants.STATUS_DIVIDER;
  }
  isInSync(): boolean {
    return true;
  }
  isOutOfSync(): boolean {
    return false;
  }
}
